<div class="manageprofile-timesheet-screen">
  <div class="col-12">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div>
        <div class="timesheetscreen-title">Working Hours</div>
        <div class="timesheetscreen-hours-details">
          Total Hours: {{headerDayTotal}} | Billable Hours: {{billabletimeVal}} <span *ngIf="billable > 0"> ({{billable}}%)</span> | Non-billable hours: {{nonbillabletimeVal}}<span *ngIf="nonbillable > 0">({{nonbillable}}%)</span>
        </div>
      </div>
      <div>
        <div class="d-flex justify-content-end">
          <div class="cmn-grid-top-right-filters">
            <div class="mr-2 cmn-slide-toggle-container">
              <mat-slide-toggle color="primary" [(ngModel)]="IsShowWeeks" (change)="UpdateWeekStauts($event)">
                <span class="slide-label-text">Show Weekends</span>
              </mat-slide-toggle>
            </div>
            <div class="mr-2" *ngIf="istimesheetStaffshow && _lststaff != undefined">
              <div class="cmn-select-filter-dropdown">
                <div class="" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <button class="btn-timesheet img-filter-icon_css kc-btn-mgr">
                    <span class="ellipsis-more-text" title="{{selectedUname}}">{{selectedUname}}</span>
                    <i class="fa fa-chevron-down group_by_css"></i>
                  </button>
                </div>
                <div class="dropdown-menu  dropdown-menu-right " aria-labelledby="dropdownMenuLinktwo">
                  <div class="grid-search-filter">
                    <img src="../../../assets/img/search-icon/search_icon.svg" class="img-responsive" />
                    <input class="form-control" type="search" [(ngModel)]="filtert" [ngModelOptions]="{standalone: true}" placeholder="Search" aria-controls="dataTable" aria-label="Search" aria-describedby="basic-addon2">
                  </div>
                  <div class="timesheet-drp-scroll">
                    <ul *ngIf="!IsMytimesheet">
                      <li class="timesheet_new_kc nav-item">
                        <a class="mr_left_timesheet" (click)="setStateAsActive('');setMyStatesAsActive(tUserid,false,'My Timesheet')">My Timesheet</a>
                      </li>
                    </ul>
                    <ul *ngIf="IsMytimesheet">
                      <li class="timesheet_new_kc nav-item Test_new_css">
                        <a class="mr_left_timesheet" (click)="setStateAsActive('');setMyStatesAsActive(tUserid,false,'My Timesheet')">My Timesheet</a>
                      </li>
                    </ul>
                    <ul class=" chk-bx" id="nav">
                      <li *ngFor="let state of _lststaff | filter:filtert "
                          (click)="setStateAsActive(state);checksetMyStatesAsActive(state.userId, true,state.name)" class="nav-item  timesheet_kc">
                        <a class="kc_time_count kc_my-time" [class.active]="state === activeState" title="{{state.name}}">{{ state.name }}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="grid-search-filter mr-2">
              <img src="../../../assets/img/search-icon/search_icon.svg" class="img-width-search-icon" />
              <input class="form-control" type="search" placeholder="Search" [(ngModel)]="filterm" [ngModelOptions]="{standalone: true}" aria-controls="dataTable" aria-label="Search" aria-describedby="basic-addon2">
            </div>
            <div class="">
              <div class="cmn-grid-daterange-picker cursor_pointer">
                <div class="cmn-grid-daterange-picker-btn">
                  <span class="daterange-icons-btn" (click)="checkWeekChangePrevious()"><i class="fa fa-chevron-left"></i></span>
                  <span class="daterange-selected-value" (click)="dp.toggle()">{{mon}} - {{Sun}}</span>
                  <span class="daterange-icons-btn" (click)="checkWeekChangeNext()"><i class="fa fa-chevron-right"></i></span>
                </div>
                <div class="col-sm-12">
                  <form #addClientForm="ngForm" (ngSubmit)="searchdata()" novalidate>
                    <input style="visibility:hidden;position:absolute;" #dp="bsDatepicker" type="text" #startdate="ngModel" name="startdate" [(ngModel)]="model.startdate" placeholder="From date"
                           (ngModelChange)="onChangesCheck($event)" bsDatepicker [minDate]="minDate" [(bsValue)]="datePickerValue" (onShown)="onOpenCalendar($event)"
                           [bsConfig]="{ showWeekNumbers: false ,dateInputFormat: 'DD MMM YYYY', 'customTodayClass': 'today', containerClass: 'timesheetDatePicker' }" [dateCustomClasses]="dateCustomClasses" />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-9 col-lg-8 col-xl-9">
        <div #addRowScroll class="cmn-table-design timesheet-table-hgt" [ngClass]="{'timesheetScrollEnable' : dynamicArray.length > 6}">
          <table class="table table-borderless mr_top_kc" [ngClass]="{'noHighlightInput' : !IsMytimesheet}">
            <thead class="">
              <tr>
                <th scope="col" style="width:27%" class="color-dark">Items</th>
                <th style="width:1%"></th>
                <th scope="col" style="width:9%">
                  <div class="d-flex justify-content-start">
                    <div class="d-flex justify-content-center align-items-center">
                      {{displayMon}}
                      <div *ngIf="IsmonHighlighter && IsMonCheckDate && IsmonHolidayHighlighter == '' " class="dot" matTooltipClass="cmn-tooltip-template light-tooltip-template" matTooltip="Not met minimum hours">
                        <img src="../../../assets/img/warning-red.svg" />
                      </div>
                    </div>
                    <div class="hover_status_new_leave ml-2">
                      <span *ngIf="IsmonHolidayHighlighter != ''" matTooltipClass="cmn-tooltip-template light-tooltip-template holiday-info-tooltip" matTooltip="{{IsmonHolidayHighlighter}}">
                        <span class="info-circle-container">
                          <i class="custom-info-icon"></i>
                        </span>
                      </span>
                    </div>
                  </div>
                </th>
                <th scope="col" style="width:9%">
                  <div class="d-flex justify-content-start">
                    <div class="d-flex justify-content-center  align-items-center">
                      {{displayTue}}
                      <div *ngIf="IstueHighlighter && IstueCheckDate && IstueHolidayHighlighter == '' " class="dot" matTooltipClass="cmn-tooltip-template light-tooltip-template" matTooltip="Not met minimum hours">
                        <img src="../../../assets/img/warning-red.svg" />
                      </div>
                    </div>
                    <div class="hover_status_new_leave ml-2">
                      <span *ngIf="IstueHolidayHighlighter != ''" matTooltipClass="cmn-tooltip-template light-tooltip-template  holiday-info-tooltip" matTooltip="{{IstueHolidayHighlighter}}">
                        <span class="info-circle-container">
                          <i class="custom-info-icon"></i>
                        </span>
                      </span>
                    </div>
                  </div>
                </th>
                <th scope="col" style="width:9%">
                  <div class="d-flex justify-content-start">
                    <div class="d-flex justify-content-center align-items-center">
                      {{displayWed}}
                      <div *ngIf="IswedHighlighter && IswedCheckDate && IswedHolidayHighlighter == '' " class="dot" matTooltipClass="cmn-tooltip-template light-tooltip-template" matTooltip="Not met minimum hours">
                        <img src="../../../assets/img/warning-red.svg" />
                      </div>
                    </div>
                    <div class="hover_status_new_leave ml-2">
                      <span *ngIf="IswedHolidayHighlighter != ''" matTooltipClass="cmn-tooltip-template light-tooltip-template holiday-info-tooltip" matTooltip="{{IswedHolidayHighlighter}}">
                        <span class="info-circle-container">
                          <i class="custom-info-icon"></i>
                        </span>
                      </span>
                    </div>
                  </div>
                </th>
                <th scope="col" style="width:9%">
                  <div class="d-flex justify-content-start">
                    <div class="d-flex justify-content-center align-items-center">
                      {{displayThr}}
                      <span *ngIf="IsthursHighlighter && IsthursCheckDate && IsthursHolidayHighlighter == '' " class="dot" matTooltipClass="cmn-tooltip-template light-tooltip-template" matTooltip="Not met minimum hours">
                        <img src="../../../assets/img/warning-red.svg" />
                      </span>
                    </div>
                    <div class="hover_status_new_leave ml-2">
                      <span *ngIf="IsthursHolidayHighlighter != ''" matTooltipClass="cmn-tooltip-template light-tooltip-template holiday-info-tooltip" matTooltip="{{IsthursHolidayHighlighter}}">
                        <span class="info-circle-container">
                          <i class="custom-info-icon"></i>
                        </span>
                      </span>
                    </div>
                  </div>
                </th>
                <th scope="col" style="width:9%">
                  <div class="d-flex justify-content-start">
                    <div class="d-flex justify-content-center align-items-center">
                      {{displayFri}}
                      <div *ngIf="IsfriHighlighter && IsfriCheckDate && IsfriHolidayHighlighter == '' " class="dot" matTooltipClass="cmn-tooltip-template light-tooltip-template" matTooltip="Not met minimum hours">
                        <img src="../../../assets/img/warning-red.svg" />
                      </div>
                    </div>
                    <div class="hover_status_new_leave ml-2">
                      <span *ngIf="IsfriHolidayHighlighter != ''" matTooltipClass="cmn-tooltip-template light-tooltip-template holiday-info-tooltip" matTooltip="{{IsfriHolidayHighlighter}}">
                        <span class="info-circle-container">
                          <i class="custom-info-icon"></i>
                        </span>
                      </span>
                    </div>
                  </div>
                </th>
                <th scope="col" style="width:9%" *ngIf="IsShowWeeks">
                  <div class="d-flex justify-content-start">
                    <div>
                      {{displaySat}}
                    </div>
                    <div class="hover_status_new_leave ml-2">
                      <span *ngIf="IssatHolidayHighlighter != ''" matTooltipClass="cmn-tooltip-template light-tooltip-template holiday-info-tooltip" matTooltip="{{IsfriHolidayHighlighter}}">
                        <span class="info-circle-container">
                          <i class="custom-info-icon"></i>
                        </span>
                      </span>
                    </div>
                  </div>
                </th>
                <th scope="col" style="width:9%" *ngIf="IsShowWeeks">
                  <div class="d-flex justify-content-start">
                    <div>
                      {{displaySun}}
                    </div>
                    <div class="hover_status_new_leave ml-2">
                      <span *ngIf="IssunHolidayHighlighter != ''" matTooltipClass="cmn-tooltip-template light-tooltip-template holiday-info-tooltip" matTooltip="{{IsfriHolidayHighlighter}}">
                        <span class="info-circle-container">
                          <i class="custom-info-icon"></i>
                        </span>
                      </span>
                    </div>
                  </div>
                </th>
                <th scope="col" style="width:8%">
                  <div class="d-flex justify-content-center color-dark">
                    Total
                  </div>
                </th>
                <th scope="col" style="width:4%" *ngIf="IsShowWeeks"></th>
                <th scope="col" style="width:2%" *ngIf="!IsShowWeeks"></th>
              </tr>
            </thead>
            <tbody class="">
              <tr class="table_tr_line_css" *ngFor="let dynamic of dynamicArray |filter:filterm let i = index;">
                <td *ngIf="dynamicArray[i].contextId == 0">
                  <div class="ng-autocomplete add-new-row-input">
                    <ng-autocomplete #autocomplete [data]="lstdata" [searchKeyword]="keyword" (selected)='selectEvent($event)'
                                     (inputChanged)='onChangeSearch($event)' (inputFocused)='onFocused($event)' [itemTemplate]="itemTemplate" class="kc_timesht_auto"
                                     [notFoundTemplate]="notFoundTemplate" placeHolder="Items" [(ngModel)]="dynamicArray[i].Items">
                    </ng-autocomplete>
                    <ng-template #itemTemplate let-item>
                      <a href="javascript:void(0)" class="hover_status_new " data-bs-toggle="dropdown" data-boundary="window">
                        <div class="">
                          <div class="overflow_css" theme="light" [tooltip]="item.name" placement="right" [max-width]="400">
                            <span [innerHTML]="item.name"> </span>
                          </div>
                        </div>
                      </a>
                    </ng-template>
                    <ng-template #notFoundTemplate let-notFound>
                      <div class="add-job-dropdn-option">
                        <a class="dropdown-item" (click)="addJobsPopup()">
                          Add Job
                        </a>
                      </div>
                    </ng-template>
                  </div>
                </td>
                <td *ngIf="dynamicArray[i].contextId != 0" class="overflowdata">
                  <span title="{{dynamic.name}}"> {{dynamic.name}}</span>
                </td>
                <td>
                  <div class="d-flex justify-content-center dollar-symbol hover_status_new" *ngIf="dynamicArray[i].context == 'JobId' " matTooltipClass="cmn-tooltip-template light-tooltip-template" matTooltip="Billable">
                    <img src="../../../assets/img/goldenDollerIcon/goldendollaricon.svg" class="golden_doller_css" />
                  </div>
                </td>
                <td>
                  <div class="col-sm-12 p-0">
                    <div class="timesheet-table-input-container">
                      <span *ngIf="dynamicArray[i].context == 'JobId'" matTooltipClass="cmn-tooltip-template light-tooltip-template" matTooltip="{{futureMonMsg}}">
                        <!--Developer: Ramya;  Ticket: CUST-1335;  Date: 03-June-2022-->
                        <input #monInput appTwoDigitDecimaNumberDirective [disabled]="dynamicArray[i].isFinalInvoice || !IsMytimesheet || dynamicArray[i].Items == '' || (IsMonDayisGreater && dynamicArray[i].context == 'JobId') || (IsmonHolidayHighlighter != '' && dynamicArray[i].context != 'JobId') " type="text"
                               [ngClass]="{'': (IsmonHolidayHighlighter == '' && dynamicArray[i].context == 'JobId'), 'txt_holiday' : (IsmonHolidayHighlighter != ''), 'txt_leave': (IsmonHolidayHighlighter == '' && dynamicArray[i].context != 'JobId')}"
                               class="form-control inpt_css  new_test_text"
                               (keypress)="numberOnly($event)" numeric [(ngModel)]="dynamicArray[i].day1" (keydown.Tab)="onKey($event)"
                               (focus)="onsetdefaultValue(dynamicArray[i],1,i);focusFunction(dynamicArray[i].context,dynamicArray[i].contextId,dynamicArray[i].name,w1);clickTimecell()"
                               (change)="onChangeCalculate(dynamicArray[i].day1,dynamicArray[i].context,dynamicArray[i].contextId,w1,w7,1,i);" />
                      </span>
                      <span *ngIf="dynamicArray[i].context != 'JobId'">
                        <input #monInput appTwoDigitDecimaNumberDirective [disabled]="dynamicArray[i].isFinalInvoice || !IsMytimesheet || dynamicArray[i].Items == '' || (IsMonDayisGreater && dynamicArray[i].context == 'JobId') || (IsmonHolidayHighlighter != '' && dynamicArray[i].context != 'JobId') " type="text"
                               [ngClass]="{'': (IsmonHolidayHighlighter == '' && dynamicArray[i].context == 'JobId'), 'txt_holiday' : (IsmonHolidayHighlighter != ''), 'txt_leave': (IsmonHolidayHighlighter == '' && dynamicArray[i].context != 'JobId')}"
                               class="form-control inpt_css  new_test_text"
                               (keypress)="numberOnly($event)" numeric [(ngModel)]="dynamicArray[i].day1" (keydown.Tab)="onKey($event)"
                               (focus)="onsetdefaultValue(dynamicArray[i],1,i);focusFunction(dynamicArray[i].context,dynamicArray[i].contextId,dynamicArray[i].name,w1);clickTimecell()"
                               (change)="onChangeCalculate(dynamicArray[i].day1,dynamicArray[i].context,dynamicArray[i].contextId,w1,w7,1,i);" />
                      </span>
                      <div class="comment_icon_kc" *ngIf="dynamicArray[i].cflagday1">
                        <img src="../../../assets/timeSheetIcon/CommentIcon.svg" />
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="col-sm-12 p-0">
                    <div class="timesheet-table-input-container">
                      <span *ngIf="dynamicArray[i].context == 'JobId'" matTooltipClass="cmn-tooltip-template light-tooltip-template" matTooltip="{{futureTueMsg}}">
                        <input appTwoDigitDecimaNumberDirective [disabled]="dynamicArray[i].isFinalInvoice || !IsMytimesheet || (IsTueDayisGreater && dynamicArray[i].context == 'JobId') || (IstueHolidayHighlighter != '' && dynamicArray[i].context != 'JobId')" type="text"
                               [ngClass]="{'': (IstueHolidayHighlighter == '' && dynamicArray[i].context == 'JobId'), 'txt_holiday' : (IstueHolidayHighlighter != ''), 'txt_leave': (IstueHolidayHighlighter == '' && dynamicArray[i].context != 'JobId')}"
                               class="form-control inpt_css  new_test_text"
                               (keypress)="numberOnly($event)" numeric [(ngModel)]="dynamicArray[i].day2" (keydown.Tab)="onKey($event)"
                               (focus)="onsetdefaultValue(dynamicArray[i],2,i);focusFunction(dynamicArray[i].context,dynamicArray[i].contextId,dynamicArray[i].name,w2);clickTimecell()"
                               (change)="onChangeCalculate(dynamicArray[i].day2,dynamicArray[i].context,dynamicArray[i].contextId,w2,w7,2,i)" />
                      </span>
                      <span *ngIf="dynamicArray[i].context != 'JobId'">
                        <input appTwoDigitDecimaNumberDirective [disabled]="dynamicArray[i].isFinalInvoice || !IsMytimesheet || (IsTueDayisGreater && dynamicArray[i].context == 'JobId') || (IstueHolidayHighlighter != '' && dynamicArray[i].context != 'JobId')" type="text"
                               [ngClass]="{'': (IstueHolidayHighlighter == '' && dynamicArray[i].context == 'JobId'), 'txt_holiday' : (IstueHolidayHighlighter != ''), 'txt_leave': (IstueHolidayHighlighter == '' && dynamicArray[i].context != 'JobId')}"
                               class="form-control inpt_css  new_test_text"
                               (keypress)="numberOnly($event)" numeric [(ngModel)]="dynamicArray[i].day2" (keydown.Tab)="onKey($event)"
                               (focus)="onsetdefaultValue(dynamicArray[i],2,i);focusFunction(dynamicArray[i].context,dynamicArray[i].contextId,dynamicArray[i].name,w2);clickTimecell()"
                               (change)="onChangeCalculate(dynamicArray[i].day2,dynamicArray[i].context,dynamicArray[i].contextId,w2,w7,2,i)" />
                      </span>
                      <div class="comment_icon_kc" *ngIf="dynamicArray[i].cflagday2">
                        <img src="../../../assets/timeSheetIcon/CommentIcon.svg" />
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="col-sm-12 p-0">
                    <div class="timesheet-table-input-container">
                      <span *ngIf="dynamicArray[i].context == 'JobId'" matTooltipClass="cmn-tooltip-template light-tooltip-template" matTooltip="{{futureWedMsg}}">
                        <input appTwoDigitDecimaNumberDirective [disabled]="dynamicArray[i].isFinalInvoice || !IsMytimesheet || (IsWedDayisGreater && dynamicArray[i].context == 'JobId') || (IswedHolidayHighlighter != '' && dynamicArray[i].context != 'JobId')" type="text"
                               [ngClass]="{'': (IswedHolidayHighlighter == '' && dynamicArray[i].context == 'JobId'), 'txt_holiday' : (IswedHolidayHighlighter != ''), 'txt_leave': (IswedHolidayHighlighter == '' && dynamicArray[i].context != 'JobId')}"
                               class="form-control inpt_css  new_test_text"
                               (keypress)="numberOnly($event)" numeric [(ngModel)]="dynamicArray[i].day3" (keydown.Tab)="onKey($event)"
                               (focus)="onsetdefaultValue(dynamicArray[i],3,i);focusFunction(dynamicArray[i].context,dynamicArray[i].contextId,dynamicArray[i].name,w3);clickTimecell()"
                               (change)="onChangeCalculate(dynamicArray[i].day3,dynamicArray[i].context,dynamicArray[i].contextId,w3,w7,3,i)" />
                      </span>
                      <span *ngIf="dynamicArray[i].context != 'JobId'">
                        <input appTwoDigitDecimaNumberDirective [disabled]="dynamicArray[i].isFinalInvoice || !IsMytimesheet || (IsWedDayisGreater && dynamicArray[i].context == 'JobId') || (IswedHolidayHighlighter != '' && dynamicArray[i].context != 'JobId')" type="text"
                               [ngClass]="{'': (IswedHolidayHighlighter == '' && dynamicArray[i].context == 'JobId'), 'txt_holiday' : (IswedHolidayHighlighter != ''), 'txt_leave': (IswedHolidayHighlighter == '' && dynamicArray[i].context != 'JobId')}"
                               class="form-control inpt_css  new_test_text"
                               (keypress)="numberOnly($event)" numeric [(ngModel)]="dynamicArray[i].day3" (keydown.Tab)="onKey($event)"
                               (focus)="onsetdefaultValue(dynamicArray[i],3,i);focusFunction(dynamicArray[i].context,dynamicArray[i].contextId,dynamicArray[i].name,w3);clickTimecell()"
                               (change)="onChangeCalculate(dynamicArray[i].day3,dynamicArray[i].context,dynamicArray[i].contextId,w3,w7,3,i)" />
                      </span>
                      <div class="comment_icon_kc" *ngIf="dynamicArray[i].cflagday3">
                        <img src="../../../assets/timeSheetIcon/CommentIcon.svg" />
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="col-sm-12 p-0">
                    <div class="timesheet-table-input-container">
                      <span *ngIf="dynamicArray[i].context == 'JobId'" matTooltipClass="cmn-tooltip-template light-tooltip-template" matTooltip="{{futureThuMsg}}">
                        <input appTwoDigitDecimaNumberDirective [disabled]="dynamicArray[i].isFinalInvoice || !IsMytimesheet || (IsThursDayisGreater && dynamicArray[i].context == 'JobId') || (IsthursHolidayHighlighter != '' && dynamicArray[i].context != 'JobId')" type="text"
                               [ngClass]="{'': (IsthursHolidayHighlighter == '' && dynamicArray[i].context == 'JobId'), 'txt_holiday' : (IsthursHolidayHighlighter != ''), 'txt_leave': (IsthursHolidayHighlighter == '' && dynamicArray[i].context != 'JobId')}"
                               class="form-control inpt_css  new_test_text"
                               (keypress)="numberOnly($event)" numeric [(ngModel)]="dynamicArray[i].day4" (keydown.Tab)="onKey($event)"
                               (focus)="onsetdefaultValue(dynamicArray[i],4,i);focusFunction(dynamicArray[i].context,dynamicArray[i].contextId,dynamicArray[i].name,w4);clickTimecell()"
                               (change)="onChangeCalculate(dynamicArray[i].day4,dynamicArray[i].context,dynamicArray[i].contextId,w4,w7,4,i)" />
                      </span>
                      <span *ngIf="dynamicArray[i].context != 'JobId'">
                        <input appTwoDigitDecimaNumberDirective [disabled]="dynamicArray[i].isFinalInvoice || !IsMytimesheet || (IsThursDayisGreater && dynamicArray[i].context == 'JobId') || (IsthursHolidayHighlighter != '' && dynamicArray[i].context != 'JobId')" type="text"
                               [ngClass]="{'': (IsthursHolidayHighlighter == '' && dynamicArray[i].context == 'JobId'), 'txt_holiday' : (IsthursHolidayHighlighter != ''), 'txt_leave': (IsthursHolidayHighlighter == '' && dynamicArray[i].context != 'JobId')}"
                               class="form-control inpt_css  new_test_text"
                               (keypress)="numberOnly($event)" numeric [(ngModel)]="dynamicArray[i].day4" (keydown.Tab)="onKey($event)"
                               (focus)="onsetdefaultValue(dynamicArray[i],4,i);focusFunction(dynamicArray[i].context,dynamicArray[i].contextId,dynamicArray[i].name,w4);clickTimecell()"
                               (change)="onChangeCalculate(dynamicArray[i].day4,dynamicArray[i].context,dynamicArray[i].contextId,w4,w7,4,i)" />
                      </span>
                      <div class="comment_icon_kc" *ngIf="dynamicArray[i].cflagday4">
                        <img src="../../../assets/timeSheetIcon/CommentIcon.svg" />
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="col-sm-12 p-0">
                    <div class="timesheet-table-input-container">
                      <span *ngIf="dynamicArray[i].context == 'JobId'" matTooltipClass="cmn-tooltip-template light-tooltip-template" matTooltip="{{futureFriMsg}}">
                        <input appTwoDigitDecimaNumberDirective [disabled]="dynamicArray[i].isFinalInvoice || !IsMytimesheet || (IsFriDayisGreater && dynamicArray[i].context == 'JobId') || (IsfriHolidayHighlighter != '' && dynamicArray[i].context != 'JobId')" type="text"
                               [ngClass]="{'': (IsfriHolidayHighlighter == '' && dynamicArray[i].context == 'JobId'), 'txt_holiday' : (IsfriHolidayHighlighter != ''), 'txt_leave': (IsfriHolidayHighlighter == '' && dynamicArray[i].context != 'JobId')}"
                               class="form-control inpt_css  new_test_text"
                               (keypress)="numberOnly($event)" numeric [(ngModel)]="dynamicArray[i].day5" (keydown.Tab)="onKey($event)"
                               (focus)="onsetdefaultValue(dynamicArray[i],5,i);focusFunction(dynamicArray[i].context,dynamicArray[i].contextId,dynamicArray[i].name,w5);clickTimecell()"
                               (change)="onChangeCalculate(dynamicArray[i].day5,dynamicArray[i].context,dynamicArray[i].contextId,w5,w7,5,i)" />
                      </span>
                      <span *ngIf="dynamicArray[i].context != 'JobId'">
                        <input appTwoDigitDecimaNumberDirective [disabled]="dynamicArray[i].isFinalInvoice || !IsMytimesheet || (IsFriDayisGreater && dynamicArray[i].context == 'JobId') || (IsfriHolidayHighlighter != '' && dynamicArray[i].context != 'JobId')" type="text"
                               [ngClass]="{'': (IsfriHolidayHighlighter == '' && dynamicArray[i].context == 'JobId'), 'txt_holiday' : (IsfriHolidayHighlighter != ''), 'txt_leave': (IsfriHolidayHighlighter == '' && dynamicArray[i].context != 'JobId')}"
                               class="form-control inpt_css  new_test_text"
                               (keypress)="numberOnly($event)" numeric [(ngModel)]="dynamicArray[i].day5" (keydown.Tab)="onKey($event)"
                               (focus)="onsetdefaultValue(dynamicArray[i],5,i);focusFunction(dynamicArray[i].context,dynamicArray[i].contextId,dynamicArray[i].name,w5);clickTimecell()"
                               (change)="onChangeCalculate(dynamicArray[i].day5,dynamicArray[i].context,dynamicArray[i].contextId,w5,w7,5,i)" />
                      </span>
                      <div class="comment_icon_kc" *ngIf="dynamicArray[i].cflagday5">
                        <img src="../../../assets/timeSheetIcon/CommentIcon.svg" />
                      </div>
                    </div>
                  </div>
                </td>
                <td *ngIf="IsShowWeeks">
                  <div class="col-sm-12 p-0">
                    <div class="timesheet-table-input-container">
                      <span *ngIf="dynamicArray[i].context == 'JobId'" matTooltipClass="cmn-tooltip-template light-tooltip-template" matTooltip="{{futureSatMsg}}">
                        <input appTwoDigitDecimaNumberDirective [disabled]="dynamicArray[i].isFinalInvoice || !IsMytimesheet || (IsSatDayisGreater && dynamicArray[i].context == 'JobId') || (IssatHolidayHighlighter != '' && dynamicArray[i].context != 'JobId')" type="text"
                               [ngClass]="{'': (IssatHolidayHighlighter == '' && dynamicArray[i].context == 'JobId'), 'txt_holiday' : (IssatHolidayHighlighter != ''), 'txt_leave': (IssatHolidayHighlighter == '' && dynamicArray[i].context != 'JobId')}"
                               class="form-control inpt_css  new_test_text"
                               (keypress)="numberOnly($event)" numeric [(ngModel)]="dynamicArray[i].day6" (keydown.Tab)="onKey($event)"
                               (focus)="onsetdefaultValue(dynamicArray[i],6,i);focusFunction(dynamicArray[i].context,dynamicArray[i].contextId,dynamicArray[i].name,w6);clickTimecell()"
                               (change)="onChangeCalculate(dynamicArray[i].day6,dynamicArray[i].context,dynamicArray[i].contextId,w6,w7,6,i)" />
                      </span>
                      <span *ngIf="dynamicArray[i].context != 'JobId'">
                        <input appTwoDigitDecimaNumberDirective [disabled]="dynamicArray[i].isFinalInvoice || !IsMytimesheet || (IsSatDayisGreater && dynamicArray[i].context == 'JobId') || (IssatHolidayHighlighter != '' && dynamicArray[i].context != 'JobId')" type="text"
                               [ngClass]="{'': (IssatHolidayHighlighter == '' && dynamicArray[i].context == 'JobId'), 'txt_holiday' : (IssatHolidayHighlighter != ''), 'txt_leave': (IssatHolidayHighlighter == '' && dynamicArray[i].context != 'JobId')}"
                               class="form-control inpt_css  new_test_text"
                               (keypress)="numberOnly($event)" numeric [(ngModel)]="dynamicArray[i].day6" (keydown.Tab)="onKey($event)"
                               (focus)="onsetdefaultValue(dynamicArray[i],6,i);focusFunction(dynamicArray[i].context,dynamicArray[i].contextId,dynamicArray[i].name,w6);clickTimecell()"
                               (change)="onChangeCalculate(dynamicArray[i].day6,dynamicArray[i].context,dynamicArray[i].contextId,w6,w7,6,i)" />
                      </span>
                      <div class="comment_icon_kc" *ngIf="dynamicArray[i].cflagday6">
                        <img src="../../../assets/timeSheetIcon/CommentIcon.svg" />
                      </div>
                    </div>
                  </div>
                </td>
                <td *ngIf="IsShowWeeks">
                  <div class="col-sm-12 p-0">
                    <div class="timesheet-table-input-container">
                      <span *ngIf="dynamicArray[i].context == 'JobId'" matTooltipClass="cmn-tooltip-template light-tooltip-template" matTooltip="{{futureSunMsg}}">
                        <input appTwoDigitDecimaNumberDirective [disabled]="dynamicArray[i].isFinalInvoice || !IsMytimesheet || (IsSunDayisGreater && dynamicArray[i].context == 'JobId') || (IssunHolidayHighlighter != '' && dynamicArray[i].context != 'JobId')" type="text"
                               [ngClass]="{'': (IssunHolidayHighlighter == '' && dynamicArray[i].context == 'JobId'), 'txt_holiday' : (IssunHolidayHighlighter != ''), 'txt_leave': (IssunHolidayHighlighter == '' && dynamicArray[i].context != 'JobId')}"
                               class="form-control inpt_css  new_test_text"
                               (keypress)="numberOnly($event)" numeric [(ngModel)]="dynamicArray[i].day7" (keydown.Tab)="onKey($event)"
                               (focus)="onsetdefaultValue(dynamicArray[i],7,i);focusFunction(dynamicArray[i].context,dynamicArray[i].contextId,dynamicArray[i].name,w7);clickTimecell()"
                               (change)="onChangeCalculate(dynamicArray[i].day7,dynamicArray[i].context,dynamicArray[i].contextId,w7,w7,7,i)" />
                      </span>
                      <span *ngIf="dynamicArray[i].context != 'JobId'">
                        <input appTwoDigitDecimaNumberDirective [disabled]="dynamicArray[i].isFinalInvoice || !IsMytimesheet || (IsSunDayisGreater && dynamicArray[i].context == 'JobId') || (IssunHolidayHighlighter != '' && dynamicArray[i].context != 'JobId')" type="text"
                               [ngClass]="{'': (IssunHolidayHighlighter == '' && dynamicArray[i].context == 'JobId'), 'txt_holiday' : (IssunHolidayHighlighter != ''), 'txt_leave': (IssunHolidayHighlighter == '' && dynamicArray[i].context != 'JobId')}"
                               class="form-control inpt_css  new_test_text"
                               (keypress)="numberOnly($event)" numeric [(ngModel)]="dynamicArray[i].day7" (keydown.Tab)="onKey($event)"
                               (focus)="onsetdefaultValue(dynamicArray[i],7,i);focusFunction(dynamicArray[i].context,dynamicArray[i].contextId,dynamicArray[i].name,w7);clickTimecell()"
                               (change)="onChangeCalculate(dynamicArray[i].day7,dynamicArray[i].context,dynamicArray[i].contextId,w7,w7,7,i)" />
                      </span>
                      <div class="comment_icon_kc" *ngIf="dynamicArray[i].cflagday7">
                        <img src="../../../assets/timeSheetIcon/CommentIcon.svg" />
                      </div>
                    </div>
                  </div>
                </td>
                <td *ngIf="dynamicArray[i].contextId != 0">
                  <div class="d-flex justify-content-center pl-0">
                    <div class="fn_wt">
                      {{dynamicArray[i].dayTotal}}
                    </div>
                  </div>
                </td>
                <td *ngIf="dynamicArray[i].contextId == 0">
                  <div class="d-flex justify-content-center pl-0">
                    <div class="fn_wt">
                      00:00
                    </div>
                  </div>
                </td>
                <td>
                  <div class="d-flex justify-content-center delete_intomark_hide" *ngIf="!dynamicArray[i].isFinalInvoice && IsMytimesheet">
                    <div class="">
                      <img src="../../../assets/img/client/client-icon/close_button.svg" class="width_intomark" (click)="deleteRow(i)" />
                    </div>
                  </div>
                </td>
              </tr>

            </tbody>
            <tfoot>
              <tr class="table_tr_line_css_add_row" *ngIf="IsMytimesheet">
                <td colspan="11">
                  <button mat-button class="add_row_css" (click)="addRow(i)">
                    + Add a row
                  </button>
                </td>
              </tr>
              <tr class="table_tr_line_css">
                <td style="width:28%">
                  <div class="total-hour-title">
                    Total hours spent
                  </div>
                </td>
                <td style="width:1%">
                  <div class="col-sm-12 p-0"></div>
                </td>
                <td style="width:9%">
                  <div [ngClass]="(IsmonHighlighter && IsMonCheckDate && IsmonHolidayHighlighter == '') ? 'total_values_display_css footercolorchange' : 'total_values_display_css'">
                    {{headerDay1}}
                  </div>
                </td>
                <td style="width:9%">
                  <div [ngClass]="(IstueHighlighter  && IstueCheckDate && IstueHolidayHighlighter == '') ? 'total_values_display_css footercolorchange' : 'total_values_display_css'">
                    {{headerDay2}}
                  </div>
                </td>
                <td style="width:9%">
                  <div [ngClass]="(IswedHighlighter && IswedCheckDate && IswedHolidayHighlighter == '')? 'total_values_display_css footercolorchange' : 'total_values_display_css'">
                    {{headerDay3}}
                  </div>
                </td>
                <td style="width:9%">
                  <div [ngClass]="(IsthursHighlighter && IsthursCheckDate && IsthursHolidayHighlighter == '')? 'total_values_display_css footercolorchange' : 'total_values_display_css'">
                    {{headerDay4}}
                  </div>
                </td>
                <td style="width:9%">
                  <div [ngClass]="(IsfriHighlighter && IsfriCheckDate && IsfriHolidayHighlighter == '') ? 'total_values_display_css footercolorchange' : 'total_values_display_css'">
                    {{headerDay5}}
                  </div>
                </td>
                <td style="width:9%" *ngIf="IsShowWeeks">
                  <div class="total_values_display_css">
                    {{headerDay6}}
                  </div>
                </td>
                <td style="width:9%" *ngIf="IsShowWeeks">
                  <div class="total_values_display_css">
                    {{headerDay7}}
                  </div>
                </td>
                <td style="width:9%">
                  <div class="total_values_display_css total-text-value">
                    {{headerDayTotal}}
                  </div>
                </td>
                <td style="width:4%" *ngIf="IsShowWeeks"></td>
                <td style="width:0%" *ngIf="!IsShowWeeks"></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <div class="col-12 col-lg-4 col-xl-3" *ngIf="IsHiderightBox">
        <div class="timesheet-task-detail-right-box">
          <div>
            <div class="timesheet-task-detail-top">
              <h4 class="timesheet-task-name">{{dynamicName}}</h4>
            </div>
            <div class="timesheet-status-date-container">
              <div class="timesheet-status-date-container-row">
                <div class="cmn-timesheet-label-text">
                  Current Status :
                </div>
                <div class="cmn-timesheet-value">
                  {{_currentStatus}}
                </div>
              </div>
              <div class="timesheet-status-date-container-row">
                <div class="cmn-timesheet-label-text">
                  Date :
                </div>
                <div class="cmn-timesheet-value">
                  {{selectedDate}}
                </div>
              </div>
            </div>
            <div class="timesheet-timespent-input">
              <div class="cmn-timesheet-label-text">Time Spent :</div>
              <div class="form-input-container">
                <input type="text" appTwoDigitDecimaNumberDirective (keypress)="numberOnly($event)" numeric [disabled]="!IsMytimesheet"
                       (change)="onChangeTimeSpent()" [(ngModel)]="timespentField" class="form-control" />
              </div>
            </div>
            <div class="timesheet-changestatus-container">
              <div class="cmn-timesheet-label-text">Change Status :</div>
              <div>
                <div class="cmn-checkbox primary-chk">
                  <mat-checkbox class="example-margin" [checked]="IsselectStatuschk" [disabled]="!IsMytimesheet || IsDisablestatusChange" [(ngModel)]="IsselectStatuschk" (change)="selectchkStatus()"></mat-checkbox>
                </div>
                <div class="change-status-dropdown" *ngIf="IsselectStatuschk">
                  <div class="cmn-autocomplete-input-container wth-drp-arrow">
                    <ng-autocomplete [data]="lstMilestonedata" [searchKeyword]="mkeyword" (selected)='selectEventSingle($event)'
                                     (inputChanged)='onChangeSearchSingle($event)' (inputFocused)='onFocusedSingle($event)' [itemTemplate]="itemTemplate"
                                     [notFoundTemplate]="notFoundTemplate" placeholder="Select status" [(ngModel)]="dynamicMilestone">
                    </ng-autocomplete>
                    <ng-template #itemTemplate let-item>
                      <a href="javascript:void(0)">
                        <div class="">
                          <div class="overflow_css">
                            <span [innerHTML]="item.statusName" data-bs-toggle="tooltip" title="{{item.statusName}}"></span>
                          </div>
                        </div>
                      </a>
                    </ng-template>
                    <ng-template #notFoundTemplate let-notFound>
                      <div [innerHTML]="notFound"></div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
            <div class="timesheet-applytime-container">
              <div class="cmn-timesheet-label-text">Apply this time :</div>
              <div class="form-multiselect-container">
                <ng-multiselect-dropdown class="cmn-multiselect-dropdown" name="item_text" [disabled]="!IsMytimesheet" [placeholder]="'Please Enter Day'"
                                         [settings]="dropdownSettings" [(ngModel)]="selectedItemsDays" [data]="cities"
                                         (onDropDownClose)="onDropDownClose()" (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)">
                </ng-multiselect-dropdown>
              </div>
            </div>
            <div class="timesheet-comments-container">
              <h6 class="comments-label-text">Add Comments</h6>
              <div class="form-textarea-container">
                <textarea class="form-control" [(ngModel)]="_comment.comment" [mention]="usersdata" [mentionConfig]="{triggerChar:'@',labelKey:'firstName'}" placeholder="Please add your comments here" style="height:140px !important" (click)="addcommentbuttonshowhide()"></textarea>
                <div class="timesheet-comment-action" *ngIf="addcommentbuttonshow">
                  <button class="send-icon" (click)="addLogComment()">
                    <i class="fa fa-paper-plane"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="timesheet-added-comments">
              <div class="timesheet-comments-list" *ngIf="commentlst.length > 0">
                <ul>
                  <li *ngFor="let item of commentlst">
                    <div class="timesheet-comments-user">{{item.shortName}}</div>
                    <p class="timesheet-comment-value"> {{item.comment}}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- empty timesheet sidebar -->
          <div class="empty-timesheet-screen" hidden>
            <div>
              <img src="../../../assets/img/empty-timesheet.png" />
              <p>Please Select A Timesheet Entry</p>
            </div>
          </div>
          <!-- empty timesheet sidebar end-->

        </div>
      </div>
    </div>
  </div>
  <div class="footer-action-buttons">
    <button mat-button class="cmn-inverse-btn mr-3" (click)="cancelbulkPublish('cancelpublish')">Discard Changes</button>
    <button mat-button type="submit" (click)="postbulktimelog();" class="cmn-blue-btn">Publish</button>
  </div>
</div>
<!-- new code -->
<div id="snackbar" class="cmn-snackbar-container">
  <div class="d-flex align-items-center">
    <div class="cmn-snackbar-icon">
      <img src="../../../assets/img/CheckMarkWhiteIcon/checkMarkIcon.svg" />
    </div>
    <div class="cmn-snackbar-content">
      <div class="cmn-snackbar-title">Status Updated!</div>
      <div class="cmn-snackbar-desc">Job status updated as {{_currentStatus}}.</div>
    </div>
    <div class="cmn-snackbar-close">
      <span class="cursor_pointer">&times;</span>
    </div>
  </div>
</div>
<div bsModal #WarningPopup="bs-modal" class="modal fade show bg_color" tabindex="-1" [config]="{ backdrop: 'static' }" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="overflow-y:hidden">
  <div class="modal-dialog-centered justify-content-center">
    <app-warningalert [warningAlertmsgcontact]="alertmsg" [warningmsgcontact]="warningmsggroupDelete" [flagForline2]="_flagForline2" (CloseonNo)="WarningPopuponeClose()" (CloseonYes)="waringpopuponeyes()"></app-warningalert>
  </div>
</div>
<div bsModal #WarningPopup="bs-modal" class="modal fade show bg_color" tabindex="-1" [config]="{ backdrop: 'static' }" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="overflow-y:hidden">
  <app-warningpopup [warningAlertmsgcontact]="alertmsg" [warningmsgcontact]="warningmsggroupDelete" [flagForline2]="_flagForline2" (CloseonNo)="WarningPopuponeClose()" (CloseonYes)="waringpopuponeyes()"></app-warningpopup>
</div>
<ng-template #createjobModalPopup>
  <app-createjob [Page]="Contactpage" [cid]="tempJobid" [clientid]="tempClientid" [isAddJob]="isAddJob" (closeCreateEditJobsPopUp)="closeCreateEditJobsPopUp()"></app-createjob>
</ng-template>
